import Swiper from 'swiper';
import 'swiper/css';
import 'swiper/css/navigation';
import { Navigation } from 'swiper/modules';
export default class InstagramFeed {
    constructor() {
        this.section = document.querySelector('.block-instagram-feed');
        this.slider = this.section.querySelector('.swiper');
        this.navigationPrev = this.section.querySelector('.slider-button-prev');
        this.navigationNext = this.section.querySelector('.slider-button-next');

        this.ready();
    }

    ready() {
        innerWidth < 1024 ? this.slider.setAttribute('dir', 'ltr') : this.slider.setAttribute('dir', 'rtl');

        new Swiper(this.slider, {
            modules: [Navigation],
            slidesPerView: 'auto',
            spaceBetween: 24,
            grabCursor: true,
            allowTouchMove: true,
            navigation: {
                nextEl: this.navigationNext,
                prevEl: this.navigationPrev,
            },
        });
    }
}

if (document.querySelector('.block-instagram-feed')) {
    new InstagramFeed();
}
